
import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d49s6ff43pgcqhvcq960', {
        method: 'POST',
        body: new URLSearchParams({
          email: email
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
      }
    } catch (error) {
      console.error('Subscription error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <section className="py-20 px-6 bg-gradient-to-br from-[#EBEBE0] to-[#F5F5F0] relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23182114' fill-opacity='0.3'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}></div>
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10">
          <div className="w-20 h-20 bg-[#D96B33]/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-check-line text-3xl text-[#D96B33]"></i>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-[#182114] mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            Thank You!
          </h2>
          
          <p className="text-xl text-[#2E3F25] mb-8" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            You've successfully subscribed to our newsletter. Get ready for exclusive insights, project updates, and tech innovations delivered to your inbox.
          </p>

          <button
            onClick={() => setIsSubmitted(false)}
            className="inline-flex items-center gap-2 px-6 py-3 bg-transparent border-2 border-[#D96B33] text-[#D96B33] rounded-full hover:bg-[#D96B33] hover:text-[#EBEBE0] transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: '"Century Gothic", sans-serif' }}
          >
            <i className="ri-arrow-left-line"></i>
            Subscribe Another Email
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-[#EBEBE0] to-[#F5F5F0] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23182114' fill-opacity='0.3'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <div className="w-20 h-20 bg-[#D96B33]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="ri-mail-line text-3xl text-[#D96B33]"></i>
        </div>
        
        <h2 className="text-4xl md:text-5xl font-bold text-[#182114] mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
          Stay In The Loop
        </h2>
        
        <p className="text-xl text-[#2E3F25] mb-8 max-w-2xl mx-auto" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
          Get exclusive insights, project updates, and the latest in web development and automation. Join our community of innovators.
        </p>

        <form onSubmit={handleSubmit} className="max-w-md mx-auto" data-readdy-form id="newsletter-subscription">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                className="w-full px-6 py-4 bg-white border-2 border-[#2E3F25]/20 rounded-full text-[#182114] placeholder-[#2E3F25]/60 focus:outline-none focus:border-[#D96B33] focus:bg-white transition-all duration-300 text-sm shadow-sm"
                style={{ fontFamily: '"Century Gothic", sans-serif' }}
              />
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-8 py-4 bg-[#D96B33] text-white rounded-full hover:bg-[#E87D4A] transition-all duration-300 font-semibold disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer shadow-lg"
              style={{ fontFamily: '"Century Gothic", sans-serif' }}
            >
              {isSubmitting ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>
                  Subscribing...
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  Subscribe
                  <i className="ri-arrow-right-line"></i>
                </span>
              )}
            </button>
          </div>
        </form>

        <p className="text-sm text-[#2E3F25]/70 mt-4" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
          No spam, ever. Unsubscribe at any time.
        </p>
      </div>
    </section>
  );
}